module.exports = __webpack_public_path__ + "static/mocaco-case-two-f4b3e5c6feee18634b216fef5431e7d7.webp";